<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>

    <Levels />
  </div>
</template>

<script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Levels from "../../components/Workflow/Definitions/Levels.vue";
export default {
  components: { LandingToolbar, Levels },
};
</script>
